import type {
  ApprovedPromotionsColumns,
  ExpiredPromotionsColumns,
  PromotionsColumns,
  PromotionsPendingApprovalColumns
} from '@library/types/promotions';
import type { TableColumn } from '@library/types/utils';

export const PAYOUT_TYPES = ['credit', 'promo'] as const;

export const PROMOTIONS_HEADER: Array<TableColumn<PromotionsColumns>> = [
  {
    column: 'id',
    essential: true,
    label: 'Promo ID',
    sortEnabled: true,
    width: 'w-[10%]'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: false,
    width: 'w-[25%]'
  },
  {
    column: 'use_by',
    essential: true,
    label: 'Use by',
    sortEnabled: true,
    width: 'w-[15%]'
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Created at',
    sortEnabled: true,
    width: 'w-[15%]'
  },
  {
    column: 'macro_promo_tag',
    essential: true,
    label: 'Macro Tag',
    sortEnabled: false,
    width: 'w-[12.5%]'
  },
  {
    column: 'micro_promo_tag',
    essential: true,
    label: 'Micro Tag',
    sortEnabled: false,
    width: 'w-[12.5%]'
  },
  {
    column: 'approved_at',
    essential: true,
    label: 'Approval',
    sortEnabled: false,
    width: 'w-[10%]'
  }
];

export const PROMOTIONS_PENDING_APPROVAL_HEADER: Array<
  TableColumn<PromotionsPendingApprovalColumns>
> = [
  {
    column: 'id',
    essential: true,
    label: 'Promo ID',
    sortEnabled: false,
    width: 'w-[10%]'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: true,
    width: 'w-2/6'
  },
  {
    column: 'memberCount',
    essential: true,
    label: 'Member Count',
    sortEnabled: true,
    width: 'w-1/6'
  },
  {
    column: 'payoutAmount',
    essential: true,
    label: 'Max Payout Amount',
    sortEnabled: true,
    width: 'w-1/6'
  },
  {
    column: 'createdAt',
    essential: true,
    label: 'Created At',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'availableAt',
    essential: true,
    label: 'Available At',
    sortEnabled: true,
    width: 'w-1/6'
  }
];

export const EXPIRED_PROMOTIONS_HEADER: Array<
  TableColumn<ExpiredPromotionsColumns>
> = [
  {
    column: 'id',
    essential: true,
    label: 'Promo ID',
    sortEnabled: false,
    width: 'w-[10%]'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: false,
    width: 'w-2/6'
  },
  {
    column: 'memberCount',
    essential: true,
    label: 'Member Count',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'payoutAmount',
    essential: true,
    label: 'Max Payout Amount',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'createdAt',
    essential: true,
    label: 'Created At',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'expiredAt',
    essential: true,
    label: 'Expired At',
    sortEnabled: false,
    width: 'w-1/6'
  }
];

export const APPROVED_PROMOTIONS_HEADER: Array<
  TableColumn<ApprovedPromotionsColumns>
> = [
  {
    column: 'id',
    essential: true,
    label: 'Promo ID',
    sortEnabled: false,
    width: 'w-[10%]'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: false,
    width: 'w-2/6'
  },
  {
    column: 'memberCount',
    essential: true,
    label: 'Member Count',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'payoutAmount',
    essential: true,
    label: 'Max Payout Amount',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'createdAt',
    essential: true,
    label: 'Created At',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'availableAt',
    essential: true,
    label: 'Available At',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'approvedBy',
    essential: true,
    label: 'Approved By',
    sortEnabled: false,
    width: 'w-2/6'
  },
  {
    column: 'approvedAt',
    essential: true,
    label: 'Approved At',
    sortEnabled: false,
    width: 'w-1/6'
  }
];
